export const hasDifferentMainBundle = (
  manifest: Record<string, unknown>,
  loadedScripts: string[],
  origin: string,
): boolean => {
  const files = manifest.files as Record<string, unknown> | undefined
  const publishedMain = files?.['main.js']
  const loadedMain = loadedScripts.find(url =>
    /\/static\/js\/main\.[a-z0-9]+\.js(?:\?|$)/i.test(url),
  )
  if (typeof publishedMain !== 'string' || !loadedMain) return false

  return new URL(publishedMain, origin).pathname !== new URL(loadedMain, origin).pathname
}
